export const Link = {
  baseStyle: {
    color: 'link.500',
  },
}
